import { logger } from 'logger'

export { plugins } from '@slite/editor'
logger.info('Loading editor plugins')
